import { WithUserNamespace } from '../../state/user';
import { getUserEmail } from './getUserEmail';
import { getUserFirstName } from './getUserFirstName';
import { getUserLastName } from './getUserLastName';

export const getContactInformation = (state: WithUserNamespace) => ({
    email: getUserEmail(state),
    firstName: getUserFirstName(state),
    lastName: getUserLastName(state),
});
